import IHasChildren from '@/types/components/IHasChildren';
import { Fade } from '@mui/material';
import React, { FC } from 'react';


interface IShowProps extends IHasChildren {
    show?: boolean;
}

const Show: FC<IShowProps> = ({
    show,
    children
}) => {
    if (!show) {
        return null;
    }

    return (
        <Fade in={true} enter={true}>
            <div>
                {children}
            </div>
        </Fade>
    )
}

export default Show